import { BASE_URLS } from '@/scripts/constants';

export const TRIAGE_ENDPOINT_NAMESPACE = 'triage';
const getTypes = hasNamespace => {
  const prefix = hasNamespace ? `${TRIAGE_ENDPOINT_NAMESPACE}/` : '';
  return {
    START_TRIAGE: `${prefix}startTriage`,
    GET_PROGRAM_GOALS: `${prefix}getProgramGoals`,
    SUBMIT_PROGRAM_GOAL: `${prefix}submitProgramGoal`,
  };
};

export const triageEndpointTypes = getTypes(true);
export const privateTypes = getTypes(false);

const api = {
  url: BASE_URLS.API_MEMBER,
  version: '1',
};
const getApiPath = configs => `${configs.api.url}/v${configs.api.version}`;

export default {
  /**
   * @memberof Endpoints/MemberAPI
   * @name member/v1/triage
   * @type POST
   * @summary Start triage
   */
  [privateTypes.START_TRIAGE]: {
    api,
    $$method: 'post',
    $$makeUrl(configs) {
      return `${getApiPath(configs)}/triage`;
    },
  },
  /**
   * @memberof Endpoints/MemberAPI
   * @name member/v1/triage/_uuid_/program-goals
   * @type POST
   * @summary Submit the user's selected program goal
   */
  [privateTypes.SUBMIT_PROGRAM_GOAL]: {
    api,
    $$method: 'post',
    $$makeUrl(configs, { uuid }) {
      return `${getApiPath(configs)}/triage/${uuid}/program-goals`;
    },
  },
  /**
   * @memberof Endpoints/MemberAPI
   * @name member/v1/triage/_uuid_/condition/special-condition
   * @type GET
   * @summary Get the user's program goals
   */
  [privateTypes.GET_PROGRAM_GOALS]: {
    api,
    $$method: 'get',
    $$makeUrl(configs, { uuid }) {
      return `${getApiPath(configs)}/triage/${uuid}/program-goals`;
    },
  },
};
